import "./ts/navigation";
import "./ts/menu";
import "./ts/scroller";
import "./ts/slider";
import "./ts/accordion";
// import "./ts/height";

import './main.css';

import simpleParallax from 'simple-parallax-js';

import { Fancybox } from "@fancyapps/ui";

import AOS from 'aos';
import 'aos/dist/aos.css';

import MatchHeight from '@tannerhodges/match-height';

AOS.init({disable: 'mobile'});

Fancybox.bind("[data-fancybox]", {
  });

  var image = document.getElementsByClassName('parax');
  new simpleParallax(image, {
    scale: 1.2,
    delay: .6,
    transition: 'cubic-bezier(0,0,0,1)'
  });

  MatchHeight.add('.articles .article');
